// ALL GLOBAL CONSTANT

/** The largest page size: the API's PageQuery limit and the most the free MUI DataGrid allows. */
export const MAX_TABLE_PAGE_SIZE = 100;

/**
 * Global Settings › Page Size List choices (the API's GlobalSettingsOptions.PageSizeLists).
 * Each starts at 20 and none goes above MAX_TABLE_PAGE_SIZE; the first is the built-in default.
 */
export const DEFAULT_PAGE_SIZE_LIST = '20,25,50,75,100';
export const PAGE_SIZE_LISTS = [DEFAULT_PAGE_SIZE_LIST, '20,30,40,50,100', '20,40,60,80,100'];

/** The page sizes a list gives: `'20,40,60,80,100'` → `[20, 40, 60, 80, 100]`. An unknown list uses the default. */
export function pageSizesOf(list: string): number[] {
  return (PAGE_SIZE_LISTS.includes(list) ? list : DEFAULT_PAGE_SIZE_LIST).split(',').map(Number);
}
